<template>
  <v-card color="pink darken-1" dark="dark" hover="hover" to="/group">
    <v-card-text style="height: 128px;">
      <v-layout align-center="align-center" justify-center column fill-height="fill-height">
        <v-progress-circular
          v-if="isLoading"
          size="70"
          width="7"
          color="white"
          indeterminate="indeterminate"
        >
        </v-progress-circular>
        <animated-number
          class="display-1 font-weight-light"
          v-if="!isLoading"
          :value="groups.length"
          :formatValue="formatToNumber"
          :duration="1000"
        >
        </animated-number>
        <div class="text-center body-1">{{ $t("labels.groups") }}</div>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import { mapGetters } from "vuex";
import groupService from "../../Group/service.js";

export default {
  data() {
    return {
      groups: [],
      isLoading: true
    };
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"])
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      return groupService.getAll(this.currentOrganization.organizationID).then(response => {
        console.log("response", response);
        if (response && response.data) {
          this.groups = response.data;
        }
        this.isLoading = false;
        return response;
      });
    },
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    }
  },
  components: {
    AnimatedNumber
  }
};
</script>

<style scoped></style>
